import React from "react";
import { getFileExtension, getFileIcon, getFormattedFileSize } from "../../utils/Utils";
import "../../assets/css/attachment.css";

export default function Attachment({ fileName, filePath, fileSize, isMsg = true }) {
  
  return (
    <div
      className={`${isMsg ? "attachment-container-msg" : ""} `}
      
      onClick={() => {
        isMsg && window.open(`${process.env.REACT_APP_S3_URL}/${filePath}`);        
      }}
    >
      <div className={`${isMsg ? "attachment-content-msg" : "attachment-content"}`}>
        <img
          src={getFileIcon(getFileExtension(fileName))}
          alt=""
          className="fileIcon-msg"
        />
        <div className={`${isMsg ? "attachment-content-info-msg" : "attachment-content-info"}`}>
          <h3>{fileName}</h3>
          <p>
            {getFormattedFileSize(fileSize)} {getFileExtension(fileName)}
          </p>
        </div>
      </div>
    </div>
    
  );
}
